import { openApi } from '@/api/request'

export default {
  getHomePage (token) {
    return openApi.get("/Rccl.OpenApi/HomePage/GetHomePage", {
      params: {
        username: token
      }
    })
  },
  GetHomePagePost (requestData) {
    return openApi.post("/Rccl.OpenApi/HomePage/GetHomePagePost",requestData)
  },
  getEmergencyMessage (requestData) {
    return openApi.post('/Rccl.OpenApi/EmergencyMessage/GetEmergencyMessage', requestData)
  },
  // 站点弹窗（维护弹窗/普通弹窗），对齐小程序 behaviors/cmsPopup.js 的用法
  getStationPopupInfo ({ userName, source, popupMessageType }) {
    return openApi.post('/Rccl.OpenApi/Share/GetStationPopupInfo', {
      userName,
      source,
      popupMessageType
    })
  },
  getSeo (url) {
    return openApi.get("/HomeApi/GetSeo", {
      params: {
        url
      }
    })
  },
  getNavItems () {
    return openApi.get("/Rccl.OpenApi/HomePage/GetNav")
  },
  GetNavPost () {
    return openApi.post("/Rccl.OpenApi/HomePage/GetNavPost")
  },
  getPageContent (url) {
    return openApi.get("/Rccl.OpenApi/PageContent/GetPageByUrl", {
      params: {
        url
      }
    })
  },
  getCallingCode () {
    return openApi.get('/Rccl.OpenApi/sendSms/getCallingCode')
  },
  getCountries () {
    return openApi.get('/Rccl.OpenApi/page/getNationality')
  },
  getPinyin (data) {
    return openApi.post('/Rccl.OpenApi/pinyin', {
      data
    })
  },
  getWechatSignature () {
    return openApi.get('/Rccl.OpenApi/PageContent/GetSignature', {
      params: {
        url: window.location.href.split('#')[0]
      }
    })
  },
  getTopFaq () {
    return openApi.get('/Rccl.OpenApi/PageContent/GetTopFaqHP')
  },
  getFaq (data) {
    return openApi.get('/Rccl.OpenApi/FAQ/Index', {
      params: data
    })
  },
  submitFaqFeedback (data) {
    return openApi.post('/Rccl.OpenApi/Faq/SubmitSuggestion', data)
  },
  cancelFaqFeedback (data) {
    return openApi.post('/Rccl.OpenApi/Faq/CancelSuggestion', data)
  },
  getShipDetail (shipCode) {
    return openApi.get('/Rccl.OpenApi/Ship/Display', {
      params: {
        shipCode
      }
    })
  },
  getShipExperience () {
    return openApi.get('/Rccl.OpenApi/Ship/Experience', {
    })
  },
  getContract () {
    return openApi.get('/Rccl.OpenApi/PageContent/GetPageContent')
  },
  getPrivacy () {
    return openApi.get('/Rccl.OpenApi/PageContent/GetPrivacy')
  },
  getRewardRule () {
    return openApi.get('/Rccl.OpenApi/PageContent/GetRewardRule')
  },
  getNews ({ offset, limit, NewsType }) {
    return openApi.get('/Rccl.OpenApi/RcclNews/GetNews', {
      params: {
        offset,
        limit,
        NewsType
      }
    })
  },
  getNewsTitle (newsId) {
    return openApi.get('/Rccl.OpenApi/RcclNews/GetNewsDetail',{
      params: {
        newsId
      }
    })
  },
  getNewsCount () {
    return openApi.get('/Rccl.OpenApi/RcclNews/ActiveCenterNewsCount')
  },
  getNewsDetail (Id) {
    return openApi.get(`/Rccl.OpenApi/RcclNews/Detail/${Id}`)
  },
  getCountryList () {
    return openApi.get('/Rccl.OpenApi/Country/CountryList')
  },
  getCityDetail (cityName) {
    return openApi.get('/Rccl.OpenApi/ShorexIntro/ShorexIntroList',{
      params: {
        cityName
      }
    })
  },
  // partnerLead(data) {
  //   return openApi.post('/Rccl.OpenApi/PartnerLead/CreateV2', data, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data'
  //     }
  //   })
  // },
  partnerLead(data) {
    return openApi.post('/Rccl.OpenApi/PartnerLead/CreateV3', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  getUDeskUrl(data) {
    return openApi.post('/Rccl.OpenApi/Udesk/GetWebIMUrl', data);
  },
  getContentByKey(data) {
    return openApi.post('/Rccl.OpenApi/RichContentApi/GetContentByKey', data);
  },
  getBannerApi(data) {
    return openApi.get('/Rccl.OpenApi/PageContent/GetBannerApi', {
      params: data
    });
  },
  
}

